<template>
  <section class="report">
    <div class="report-title-wrap">
      <!--<div v-if="$i18n.locale === 'ko'" class="agree-wrap">
        <div v-if="$t('informationCenter.consult.notice.list')" class="agree-content">
          <div class="agree-term center-agree-term">
            <html-view tag="p" :value="$t('informationCenter.consult.notice.desc')" />
            <ul>
              <template v-for="(item, key) in $t('informationCenter.consult.notice.list')">
                <html-view :key="key" tag="li" :value="item" />
              </template>
            </ul>
          </div>
        </div>
      </div>-->

      <!--<h4 class="report-title">{{ $t('informationCenter.customerServiceCenter.head') }}</h4>-->
      <html-view :value="$t('informationCenter.customerServiceCenter.copy')" tag="p" class="report-title-desc" />
    </div>

    <validation-observer
      ref="observer"
      v-slot="{ invalid }"
      tag="section"
    >
      <form @submit.prevent="submit">
        <div class="support-form">
          <div class="agree-wrap">
            <p class="form-title">
              {{ $t('informationCenter.customerServiceCenter.user') }}
            </p>
            <div class="agree-content">
              <ul class="agree-term">
                <template v-for="(item, key) in $t('informationCenter.customerServiceCenter.userInfo')">
                  <html-view :key="key" tag="li" :value="item" />
                </template>
              </ul>
            </div>
          </div>
          <div class="agree-wrap">
            <p class="form-title">
              {{ $t('informationCenter.customerServiceCenter.partner') }}
            </p>
            <div class="agree-content">
              <ul class="agree-term">
                <template v-for="(item, key) in $t('informationCenter.customerServiceCenter.partnerInfo')">
                  <html-view :key="key" tag="li" :value="item" />
                </template>
              </ul>
            </div>
          </div>

          <input-form
            id="subject"
            ref="subject"
            v-model="subject"
            :title="$t('informationCenter.customerServiceCenter.form.subject')"
            name="subject"
            :placeholder="$t('informationCenter.customerServiceCenter.form.subjectPlaceholder')"
            type="text"
            autocomplete="off"
            required="required"
            maxlength="50"
          />
          <input-form
            id="mail"
            ref="mail"
            v-model="mail"
            :title="$t('informationCenter.customerServiceCenter.form.email')"
            name="mail"
            :placeholder="$t('informationCenter.customerServiceCenter.form.emailPlaceholder')"
            type="email"
            autocomplete="off"
            required="required"
            maxlength="50"
          />
          <input-form
            id="tel"
            ref="tel"
            v-model="tel"
            :title="$t('informationCenter.customerServiceCenter.form.tel')"
            name="tel"
            :placeholder="$t('informationCenter.customerServiceCenter.form.telPlaceholder')"
            type="tel"
            autocomplete="off"
            required="required"
            maxlength="20"
          />
          <input-form
            id="textarea"
            ref="textarea"
            v-model="textarea"
            :title="$t('informationCenter.customerServiceCenter.form.detail')"
            name="textarea"
            :placeholder="$t('informationCenter.customerServiceCenter.form.detailPlaceholder')"
            type="textarea"
            autocomplete="off"
            required="required"
            maxlength="20000"
          />
          <input-form
            id="file"
            v-model="file"
            :title="$t('informationCenter.customerServiceCenter.form.attachFile')"
            :placeholder="$t('informationCenter.customerServiceCenter.form.attachFilePlaceholder')"
            type="file"
            :is-upload="attachFileUrl !== null"
            :loading="fileLoading"
            :error-message="fileError"
            @input="attachUpload"
            @change:delete="onDeleteFile"
          >
            <small>{{ $t('informationCenter.customerServiceCenter.form.attachFileNote') }}</small>
          </input-form>
        </div>

        <div class="support-agree">
          <div class="agree-wrap agree-consult">
            <div class="agree-title">{{ $t('informationCenter.customerServiceCenter.form.privateTitle') }}</div>
            <div class="agree-content">
              <html-view class="agree-term" :value="$t('informationCenter.customerServiceCenter.form.privateValue')" />
              <div class="agree-check">
                <check-box
                  id="private"
                  ref="private"
                  v-model="agreePrivate"
                  :text="$t('informationCenter.customerServiceCenter.form.private')"
                  name="agree-private"
                  required="required"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="support-btn">
          <button type="submit" class="btn btn-fill btn-wide" :disabled="invalid">{{ $t('informationCenter.customerServiceCenter.form.submit') }}</button>
        </div>
      </form>
    </validation-observer>
  </section>
</template>
<script>
import supportForm from '@/mixins/supportForm'

export default {
  mixins: [supportForm],
  watch: {
    agreePrivate (v) {
      this.agreeAll = v
    }
  },
  mounted () {
    this.questionType = 'CUSTOMER'
  },
  methods: {
    submit () {
      this.saveQuestion({
        title: this.subject,
        name: this.name,
        email: this.mail,
        content: this.textarea,
        phoneNumber: this.tel,
        type: ['CUSTOMER', 'CONSULT']
      }, 'Main', {
        locale: this.$route.params.locale
      })
    },
    onChangeAgreeAll (v) {
      if (v) {
        this.agreePrivate = true
        this.agreePrecautions = true
      } else {
        this.agreePrivate = false
        this.agreePrecautions = false
      }
    }
  }
}
</script>
